(function(angular, module) {var getLastId, newProgramController, states;

newProgramController = function($http, $q, $state, ApiUrl, last_id) {
  'ngInject';
  this.data = {
    id: last_id + 1
  };
  this.validateId = function(id) {
    return $http.get(ApiUrl('program', 'id_used'), {
      params: {
        id: id
      }
    }).then(function(r) {
      console.log(r.data.used);
      if (r.data.used) {
        return $q.reject(true);
      } else {
        return false;
      }
    });
  };
  this.save = function(data) {
    return $http.post(ApiUrl('program'), data).then(function(r) {
      var slug;
      slug = r.data.item.slug;
      $state.go('program.info.details', {
        slug: slug
      });
    });
  };
};

getLastId = function($http, ApiUrl) {
  'ngInject';
  return $http.get(ApiUrl('program', 'last_id')).then(function(r) {
    return r.data.id;
  });
};

states = function($stateProvider) {
  'ngInject';
  return $stateProvider.state('newProgram', {
    parent: 'basic',
    url: '/program/new',
    permission: 'createProgram',
    templateUrl: 'programs/admin/new',
    controllerAs: 'newProgram',
    controller: newProgramController,
    resolve: {
      last_id: getLastId
    }
  });
};

module.config(states);
})(angular, angular.module("dybProgramsAdmin"));